import { GlobalClaim } from './GlobalClaims.types';

const AMOUNT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function displayAmount(
  value: number | null,
  currency: string | null
): string {
  if (value === null || value === undefined) return '-';
  const formatted = AMOUNT.format(value);
  return currency ? `${formatted} ${currency}` : formatted;
}

/*
 * Refused and unsettled claims read as problems, settled ones as done, and
 * anything GLOBAL is still working on as pending.
 */
export function statusColor(claim: GlobalClaim): string {
  const status = (claim.status || '').toLowerCase();
  if (status.includes('refused') || status.includes('no settlement')) {
    return 'danger';
  }
  if (status.includes('settled')) return 'success';
  if (claim.stage === 'Under Process') return 'warning';
  return '';
}
